import React, { Fragment } from 'react';
import { Row, Col, Table, Badge } from 'reactstrap';
import { formattedDateOnly } from '../../../../../utilities/formatedDate';


const TravellerDetails = ({ data }) => {

    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
                    <Table>
                        <tbody>
                            <tr>
                                <th>Title</th>
                                <td className="text-right pr-5">
                                    {data?.travellers[0]?.title ? data?.travellers[0]?.title : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>First Name</th>
                                <td className="text-right pr-5">
                                    {data?.travellers[0]?.firstName ? data?.travellers[0]?.firstName : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Middle Name</th>
                                <td className="text-right pr-5">
                                    {data?.travellers[0]?.middleName ? data?.travellers[0]?.middleName : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Last Name</th>
                                <td className="text-right pr-5">
                                    {data?.travellers[0]?.lastName ? data?.travellers[0]?.lastName : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>{data?.travellers[0]?.isOci ? 'OCI No' : 'Passport No'}</th>
                                <td className="text-right pr-5">
                                    {data?.travellers[0]?.traveller_passport ? data?.travellers[0]?.traveller_passport : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>DOB</th>
                                <td className="text-right pr-5">
                                    {data?.travellers[0]?.traveller_dob ? formattedDateOnly(data?.travellers[0]?.traveller_dob) : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Critical Illness</th>
                                <td className="text-right pr-5">
                                    {data?.travellers[0]?.critical_illness ? data?.travellers[0]?.critical_illness : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Pre existing disease</th>
                                <td className="text-right pr-5">
                                    {/* <Badge color={data?.travellers[0]?.pre_existing_disease === true ? 'success' : 'warning'}> */}
                                    <Badge color={'warning'}>
                                        {data?.travellers[0]?.pre_existing_disease ? data?.travellers[0]?.pre_existing_disease : '-'}
                                    </Badge>
                                </td>
                            </tr>
                            {data?.travellers[0]?.pre_existing_disease == "YES" && (
                                <>

                                    <tr>
                                        <th>PED Type</th>
                                        <td className="text-right pr-5">
                                            {data?.travellers[0]?.ped_type ? data?.travellers[0]?.ped_type : '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Suffering Since</th>
                                        <td className="text-right pr-5">
                                            {data?.travellers[0]?.suffering_since ? data?.travellers[0]?.suffering_since : '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Under Medication</th>
                                        <td className="text-right pr-5">
                                            {data?.travellers[0]?.under_medication ? data?.travellers[0]?.under_medication : '-'}
                                        </td>
                                    </tr>
                                    {/* <tr>
                                        <th>Medicine Name</th>
                                        <td className="text-right pr-5">
                                            {data?.travellers[0]?.medicine_name ? data?.travellers[0]?.medicine_name : '-'}
                                        </td>
                                    </tr> */}
                                </>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default TravellerDetails;